/** @deprecated Legacy single-flag key; reconciled via reconcileLegacyPopupAcknowledgment. */
export const PROMOTION_MODAL_SEEN_KEY = "promotion-modal-seen";

export const PROMOTION_MODAL_ACKNOWLEDGED_IDS_KEY = "promotion-modal-acknowledged-ids";

export const PAYMENT_UPDATED_PARAM = "payment_updated";

export const UPDATED_MEMBERSHIP_ID_PARAM = "updated_membership";
